module.exports = __webpack_public_path__ + "ca2059b5668eda3dcbd9e97c67d1926c.woff2";